/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

/**
 * Status
 */
export type CardTransactionResponseStatus = typeof CardTransactionResponseStatus[keyof typeof CardTransactionResponseStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CardTransactionResponseStatus = {
  SUCCESS: 'SUCCESS',
  PENDING: 'PENDING',
  VOID: 'VOID',
  DECLINED: 'DECLINED',
} as const;
